/**
 * LookoutShareWatcher — runs globally (mounted in App.jsx).
 * Polls the share inbox every 45 seconds; toasts when a new order is
 * shared with the current user. Works no matter which page they're on.
 */
import { useLookoutShareNotifications } from '../hooks/useLookoutShareNotifications';

export default function LookoutShareWatcher() {
  useLookoutShareNotifications();
  return null;
}
